import { render, staticRenderFns } from "./NcrCorrectiveDetail.vue?vue&type=template&id=72492fc3&"
import script from "./NcrCorrectiveDetail.vue?vue&type=script&lang=js&"
export * from "./NcrCorrectiveDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports